import React, { useRef, useState } from "react";
import { Toast } from "primereact/toast";
import { TabMenu } from "primereact/tabmenu";
import { ExportHistoryIcon } from "../../../layout/sidebar/SideBarSVGs";
import JobsheetBelfastHistory from "./JobsheetBelfastHistory";
import JobsheetGloucesterHistory from "./JobsheetGloucesterHistory";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";

const FormsExportHistory: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const toast = useRef<Toast>(null);

  const items = [
    {
      label: "Jobsheet Belfast",
      // icon: "pi pi-fw pi-building",
    },
    {
      label: "Jobsheet Gloucester",
      // icon: "pi pi-fw pi-home",
    },
  ];

  const renderTabContent = () => {
    switch (activeIndex) {
      case 0:
        return <JobsheetBelfastHistory toast={toast} />;
      case 1:
        return <JobsheetGloucesterHistory toast={toast} />;
      default:
        return <JobsheetBelfastHistory toast={toast} />;
    }
  };

  return (
    <div className="tw-min-h-screen tw-bg-gray-50">
      <Toast ref={toast} />

      {/* Header Section */}
      <div className="tw-bg-white tw-rounded-none tw-shadow-2xl tw-p-[14px] tw-border-b-2 tw-border-gray-300">
        <div className="tw-flex tw-items-center tw-gap-3">
          <div className="tw-p-2 tw-bg-blue-50 tw-rounded-lg">
            <ExportHistoryIcon fill={"#3b82f6"} />
          </div>
          <div>
            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-900">
              Forms Export History
            </h1>
            <p className="tw-text-gray-600 tw-text-sm tw-mt-1">
              View and download your exported jobsheet forms
            </p>
          </div>
        </div>
      </div>
      {/* <Divider className="tw-bg-gray-400 " /> */}
      {/* Main Content */}
      <div className="tw-bg-white tw-rounded-none tw-shadow-sm tw-overflow-hidden">
        {/* Tab Navigation */}

        {/* <div className="tw-border-b-2 tw-border-gray-200"> */}
        <div>
          {/* <div className="tw-flex tw-justify-start tw-items-center tw-flex-col tw-gap-2 sm:tw-flex-row sm:tw-items-stretch sm:tw-gap-2"> */}
          <div className="tw-flex tw-justify-start tw-items-center tw-flex-col sm:tw-flex-row sm:tw-items-stretch">
            <Button
              type="button"
              onClick={() => setActiveIndex(0)}
              className={` ${
                activeIndex === 0
                  ? "tw-border-0 tw-border-b-2 tw-border-b-solid tw-border-b-[#00AFEE] tw-rounded-none tw-bg-[#f3f4f6]"
                  : "tw-text-[#7b7e7b] tw-bg-transparent"
              } focus:tw-shadow-none tw-text-xl tw-px-4 tw-py-[10px] tw-font-semibold`}
            >
              Jobsheet Belfast
            </Button>
            <Button
              type="button"
              onClick={() => setActiveIndex(1)}
              className={`tw-bg-transparent ${
                activeIndex === 1
                  ? "tw-border-0 tw-border-b-2 tw-border-b-solid tw-border-b-[#00AFEE] tw-rounded-none tw-bg-[#f3f4f6]"
                  : "tw-text-[#7b7e7b]"
              }  focus:tw-shadow-none tw-px-4 tw-py-[10px] tw-text-xl tw-font-semibold`}
            >
              Jobsheet Gloucester{" "}
            </Button>
          </div>
          {/* <TabMenu
            model={items}
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="custom-tab-menu"
          /> */}
        </div>

        {/* Tab Content */}
        <div className="tw-p-6">{renderTabContent()}</div>
      </div>

      {/* Custom Tab Styles */}
      <style>{`
        .custom-tab-menu .p-tabmenu-nav {
          background: transparent !important;
          border: none !important;
          padding: 0 !important;
        }
        
        .custom-tab-menu .p-menuitem {
          margin: 0 !important;
        }
        
        .custom-tab-menu .p-menuitem-link {
          background: transparent !important;
          border: none !important;
          padding: 16px 24px !important;
          color: #6b7280 !important;
          border-bottom: 3px solid transparent !important;
          transition: all 0.2s ease !important;
          border-radius: 0 !important;
        }
        
        .custom-tab-menu .p-menuitem-link:hover {
          background: #f3f4f6 !important;
          color: #3b82f6 !important;
        }
        
        .custom-tab-menu .p-menuitem-link.p-menuitem-link-active {
          background: #f8fafc !important;
          color: #3b82f6 !important;
          border-bottom: 3px solid #3b82f6 !important;
          font-weight: 600 !important;
        }
      `}</style>
    </div>
  );
};

export default FormsExportHistory;
